import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const authBaseUrl = '/api/auth';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, LoginForm>({
      query: (body) => ({
        url: `${authBaseUrl}/login`,
        method: 'POST',
        body,
      }),
    }),
    validateResetPassword: builder.query<AuthResponse, ValidateResetPasswordPayload>({
      query: (data) => ({
        url: `${authBaseUrl}/validate-reset-password?userId=${data.userId}`,
        method: 'GET',
      }),
    }),
    resetPassword: builder.mutation<{ success: boolean }, ResetPasswordPayload>({
      query: (body) => ({
        url: `${authBaseUrl}/reset-password`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useLoginMutation, useResetPasswordMutation, useValidateResetPasswordQuery } =
  authApi;
